import { Extension } from "@tiptap/core";

const toPt = (raw) => {
  if (!raw) return null;
  const value = parseFloat(raw);
  if (Number.isNaN(value)) return null;

  let pt = value;
  if (raw.includes("cm")) pt = value * 28.3465;
  else if (raw.includes("mm")) pt = value * 2.83465;
  else if (raw.includes("in")) pt = value * 72;
  else if (raw.includes("px")) pt = value * 0.75;

  return Math.round(pt * 100) / 100;
};

const ParagraphSpacing = Extension.create({
  name: "paragraphSpacing",

  addOptions() {
    return {
      types: ["paragraph", "heading"],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          spacingBefore: {
            default: null,
            parseHTML: (element) => toPt(element.style.marginTop),
            renderHTML: (attributes) => {
              if (attributes.spacingBefore == null) return {};
              return { style: `margin-top: ${attributes.spacingBefore}pt` };
            },
          },
          spacingAfter: {
            default: null,
            parseHTML: (element) => toPt(element.style.marginBottom),
            renderHTML: (attributes) => {
              if (attributes.spacingAfter == null) return {};
              return { style: `margin-bottom: ${attributes.spacingAfter}pt` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setParagraphSpacingBefore:
        (value) =>
        ({ tr, state, dispatch }) => {
          const { from, to } = state.selection;
          state.doc.nodesBetween(from, to, (node, pos) => {
            if (this.options.types.includes(node.type.name) && dispatch) {
              tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                spacingBefore: value,
              });
            }
          });
          return true;
        },
      setParagraphSpacingAfter:
        (value) =>
        ({ tr, state, dispatch }) => {
          const { from, to } = state.selection;
          state.doc.nodesBetween(from, to, (node, pos) => {
            if (this.options.types.includes(node.type.name) && dispatch) {
              tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                spacingAfter: value,
              });
            }
          });
          return true;
        },
    };
  },
});

export default ParagraphSpacing;
